import React from "react";

const BoxAction = ({ color, title, value, icon, width, titleColor }) => {
  return (
    <div
      className="flex flex-col p-4 rounded-lg shadow-md"
      style={{ backgroundColor: color, width, color: titleColor }}
    >
      <div className="flex justify-between items-center">
        <div className="flex flex-col w-[60%]">
          <span className="text-[35px] font-bold">{value}</span>
          <span className="text-[16px]">{title}</span>
        </div>
        <div className="flex items-center justify-center w-[40%]">
          <div>{icon}</div>
        </div>
      </div>
    </div>
  );
};

export default BoxAction;
